// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.eGtXp3:link,\n.eGtXp3:hover,\n.eGtXp3:visited,\n.eGtXp3:active {\n    color: inherit;\n    text-decoration: underline !important;\n}\n\n.eGtXp3:focus {\n    outline: rgb(193,228,254) solid 3px;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "eGtXp3"
};
export default ___CSS_LOADER_EXPORT___;
